import React, { useState, useMemo, useCallback } from 'react'
import styled from 'styled-components'
import { colors } from 'src/constants/marketing-ds'
import { TWEET_OPTIONS } from './data/tweets'
import Navigation from './components/Navigation'
import HeroSection from './components/HeroSection'
import DemandsSection from './components/DemandsSection'
import ComparisonTable from './components/ComparisonTable'
import VoiceSection from './components/VoiceSection'
import FAQSection from './components/FAQSection'
import Footer from './components/Footer'

const NBCDispute = () => {
  const [activeFaq, setActiveFaq] = useState(null)
  const [currentTweetIndex, setCurrentTweetIndex] = useState(() =>
    Math.floor(Math.random() * TWEET_OPTIONS.length)
  )

  const toggleFaq = useCallback((index) => {
    setActiveFaq((prev) => (prev === index ? null : index))
  }, [])

  const scrollToFacts = useCallback(() => {
    const element = document.getElementById('facts')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  const tweetText = useMemo(
    () => encodeURIComponent(TWEET_OPTIONS[currentTweetIndex]),
    [currentTweetIndex]
  )

  const handleTweetClick = useCallback(() => {
    setCurrentTweetIndex((prev) => (prev + 1) % TWEET_OPTIONS.length)
  }, [])

  return (
    <PageContainer>
      <Navigation />
      <HeroSection
        onScrollToFacts={scrollToFacts}
        tweetText={tweetText}
        onTweetClick={handleTweetClick}
      />
      <DemandsSection />
      {/* <VersantSection /> */}
      <ComparisonTable />
      <VoiceSection tweetText={tweetText} onTweetClick={handleTweetClick} />
      <FAQSection activeFaq={activeFaq} onToggleFaq={toggleFaq} tweetText={tweetText} />
      <Footer />
    </PageContainer>
  )
}

export default NBCDispute

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: ${colors.slate[190]};
  color: ${colors.slate[60]};
  cursor: default;
  overflow: hidden;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;

  ::selection {
    background-color: #fb923c;
    color: ${colors.white};
  }
`
